<template>
  <div v-if="relations">
    <wo-card>
      <po-table v-if="hasRelations">
        <po-table-header :columns="tableColumns" slot="header" />
        <template slot="body">
          <tr v-for="relation in relations.items" :key="relation.id">
            <td><po-route-link :value="getRoute(relation.subject)" :label="relation.subject.name" /></td>
            <td><po-route-link :value="getRoute(relation.related)" :label="relation.related.name" /></td>
            <td><po-display :value="relation.type" /></td>
          </tr>
        </template>
      </po-table>
      <po-empty-state v-else />
      <po-paging v-model="currentPage" :data="relations" />
    </wo-card>
  </div>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { Company } from '@/model/company'
import { companyRelationRepository } from '@/repository/company'

import { ADMIN_COMPANY } from '@/routes/admin'

export default {
  mixins: [filtered],
  props: {
    company: Company,
    filter: Object
  },
  computed: mapState({
    relations: state => state.company.companyRelationList,
    hasRelations () {
      return this.relations && !_.isEmpty(this.relations.items)
    },
    tableColumns () {
      return [
        { labelKey: 'companyRelation.subject' },
        { labelKey: 'companyRelation.related' },
        { labelKey: 'companyRelation.type' }
      ]
    }
  }),
  created () {
    this.doFilter()
  },
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(companyRelationRepository.findAll, { filter: filter })
    },
    getRoute (company) {
      return {
        name: ADMIN_COMPANY,
        params: { companyId: company.id }
      }
    }
  }
}
</script>
